module.exports = __webpack_public_path__ + "img/SC.9696dc0d.jpg";